import { useEffect, useState } from 'react';
import {
  getCachedCorpusRepository,
  loadCorpusRepository,
  type CorpusRepository,
} from './corpusRepository';

export function useCorpusRepository(enabled = true): {
  repository: CorpusRepository | null;
  error: string | null;
} {
  const [repository, setRepository] = useState<CorpusRepository | null>(getCachedCorpusRepository);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || repository) return;
    let live = true;
    void loadCorpusRepository()
      .then((next) => {
        if (live) setRepository(next);
      })
      .catch((reason: unknown) => {
        if (live) {
          setError(reason instanceof Error ? reason.message : 'Could not load the library.');
        }
      });
    return () => {
      live = false;
    };
  }, [enabled, repository]);

  return { repository, error };
}
